const beta = {
  keyGTM: false,
  keycloak: {
    url: import.meta.env.VITE_BETA_CONFIG_KEYCLOAK_URL,
    realm: import.meta.env.VITE_BETA_CONFIG_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_BETA_CONFIG_KEYCLOAK_CLIENT,
    credentials: {
      secret: import.meta.env.VITE_BETA_CONFIG_KEYCLOAK_SECRET,
    },
  },
  hosts: {
    portal: import.meta.env.VITE_BETA_HOST_PORTAL,
    help: import.meta.env.VITE_BETA_HOST_HELP,
    image: import.meta.env.VITE_BETA_HOST_IMAGE,
    reports: import.meta.env.VITE_BETA_HOST_APP_REPORTS,
    cso: import.meta.env.VITE_BETA_HOST_APP_CSO,
  },
  services: {
    portal: import.meta.env.VITE_BETA_SERVICE_PORTAL_API,
  },
  app: {
    accessMSDLink: import.meta.env.VITE_BETA_ACCESS_MSD_LINK,
    defaultLang: import.meta.env.VITE_BETA_VAR_DEFAULT_LANG,
    availableLangs: import.meta.env.VITE_BETA_VAR_AVAILABLE_LANGS,
  },
  referral: {
    conciergeProductId: import.meta.env.VITE_BETA_REFERRAL_CONCIERGE_PRODUCT_ID,
  },
  openReplay: {
    projectKey: import.meta.env.VITE_BETA_OPENREPLAY_PROJECT_KEY,
    ingestPoint: import.meta.env.VITE_BETA_OPENREPLAY_INGEST_POINT,
  },
};

const production = {
  // keyGTM: "G-6GLF5VBZKF",
  keyGTM: "GTM-549M8V2K",
  keycloak: {
    url: import.meta.env.VITE_PROD_CONFIG_KEYCLOAK_URL,
    realm: import.meta.env.VITE_PROD_CONFIG_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_PROD_CONFIG_KEYCLOAK_CLIENT,
    credentials: {
      secret: import.meta.env.VITE_PROD_CONFIG_KEYCLOAK_SECRET,
    },
  },
  hosts: {
    portal: import.meta.env.VITE_PROD_HOST_PORTAL,
    help: import.meta.env.VITE_PROD_HOST_HELP,
    image: import.meta.env.VITE_PROD_HOST_IMAGE,
    reports: import.meta.env.VITE_PROD_HOST_APP_REPORTS,
    cso: import.meta.env.VITE_PROD_HOST_APP_CSO,
  },
  services: {
    portal: import.meta.env.VITE_PROD_SERVICE_PORTAL_API,
  },
  app: {
    accessMSDLink: import.meta.env.VITE_PROD_ACCESS_MSD_LINK,
    defaultLang: import.meta.env.VITE_PROD_VAR_DEFAULT_LANG,
    availableLangs: import.meta.env.VITE_PROD_VAR_AVAILABLE_LANGS,
  },
  referral: {
    conciergeProductId: import.meta.env.VITE_PROD_REFERRAL_CONCIERGE_PRODUCT_ID,
  },
  openReplay: {
    projectKey: import.meta.env.VITE_PROD_OPENREPLAY_PROJECT_KEY,
    ingestPoint: import.meta.env.VITE_PROD_OPENREPLAY_INGEST_POINT,
  },
};

const env =
  window.location.hostname.includes("my.petrosoftinc") ||
  window.location.hostname.includes("petrosoftportal.azurewebsites.net")
    ? production
    : beta;

export default env;